import cx from 'classnames'
import React from 'react'
import { FieldProps, FieldRenderProps } from 'react-final-form'

import Error from '@cinch/oxd-components/error/src'
import showError from '@cinch/oxd-components/error/src/show-realtime-error'
import Label from '@cinch/oxd-components/label/src'

import styles from './filter-range.module.css'

interface RangeProps extends FieldRenderProps, Pick<FieldProps, 'parse'>, React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  min?: number
  max?: number
  step?: number
  valueFormatter?: (value: any) => string
  className?: string
  hideValue?: boolean
}

const FilterRange: React.FC<RangeProps> = ({
  input,
  meta,
  label,
  min,
  max,
  step,
  valueFormatter,
  className,
  hideValue,
}) => {
  const id = input.name
  const value = (valueFormatter && input && valueFormatter(input.value)) || (input && input.value) || ''
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => input.onChange(parseInt(event.target.value, 10))
  const scrollParent: HTMLElement | null =
    typeof document !== 'undefined'
      ? document.querySelector('[data-id="card-body"]') || (document.documentElement as HTMLElement)
      : null

  const deactivateParentScroll = () => {
    if (scrollParent) {
      scrollParent.style.overflow = 'hidden'
    }
  }

  const reactivateParentScroll = () => {
    if (scrollParent) {
      scrollParent.style.overflow = 'auto'
    }
  }

  return (
    <div className={cx([styles.label, className])}>
      {label && <Label inputId={id}>{label}</Label>}
      {!hideValue && <span className={styles.value}>{value}</span>}
      <input
        id={id}
        onTouchStart={deactivateParentScroll}
        onTouchEnd={reactivateParentScroll}
        className={styles.range}
        {...input}
        aria-invalid={showError(meta)}
        aria-valuenow={value}
        onChange={onChange}
        min={min}
        max={max}
        step={step}
        type="range"
      />
      <Error meta={meta} />
    </div>
  )
}

FilterRange.defaultProps = {
  valueFormatter: (value) => value,
  meta: {},
}

export default FilterRange
